import { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Analytics } from './services/analytics';
import FleetMarketing from './pages/FleetMarketing';
import FleetDemoRequest from './pages/FleetDemoRequest';
import FleetFeatures from './pages/FleetFeatures';
import PcoHireWorkflow from './pages/PcoHireWorkflow';
import PremiumConcept from './pages/PremiumConcept';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

// Page view tracker
const PageTracker = () => {
  const location = useLocation();
  const hasTrackedInitialPage = useRef(false);

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    Analytics.track('$pageview', { path });

    // The initial document load is already tracked by the Meta Pixel snippet in index.html.
    if (!hasTrackedInitialPage.current) {
      hasTrackedInitialPage.current = true;
      return;
    }

    if (typeof window !== 'undefined' && typeof (window as any).fbq === 'function') {
      (window as any).fbq('track', 'PageView');
    }
  }, [location.hash, location.pathname, location.search]);

  return null;
};

const HashScroller = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const targetId = decodeURIComponent(location.hash.slice(1));
    const timer = window.setTimeout(() => {
      document.getElementById(targetId)?.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }, 80);

    return () => window.clearTimeout(timer);
  }, [location.hash, location.pathname]);

  return null;
};

// Initialize analytics on app load
Analytics.init();

function App() {
  return (
    <BrowserRouter>
      <PageTracker />
      <HashScroller />
      <Routes>
        {/* Main landing page */}
        <Route path="/" element={<PremiumConcept />} />

        {/* Fleet/B2B marketing pages */}
        <Route path="/fleet" element={<FleetMarketing />} />
        <Route path="/fleet/demo" element={<FleetDemoRequest />} />
        <Route path="/fleet/features" element={<FleetFeatures />} />
        <Route path="/pco-hire-pcn-management" element={<PcoHireWorkflow />} />

        {/* Real-asset premium concept preview */}
        <Route path="/premium-concept" element={<PremiumConcept />} />

        {/* Legal pages */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        {/* Catch-all renders the main landing page */}
        <Route path="*" element={<PremiumConcept />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

